interface IOptions {
    label: string;
    value: string;
  }


export const RaceList: Array<IOptions> = [
    {
      label: 'African',
      value: '1',
    },
    {
      label: 'Coloured',
      value: '2',
    },
    {
      label: 'Indian',
      value: '3',
    },
    {
      label: 'White',
      value: '4',
    },
    {
      label: 'Non_South_African',
      value: '5',
    },
  ];